import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2024 Wasay Mohammed Abdul. All rights reserved.</p>
        <p>Built with <i className="fas fa-heart"></i> and modern web technologies</p>
      </div>
    </footer>
  );
};

export default Footer;

